'use client'
import { HTMLAttributeAnchorTarget, useContext } from 'react'
import styles from './CTAButton.module.scss'
import { classNames } from '@/src/helpers/component'
import SVGChevron from '@/src/components/common/SVG/SVGChevron'
import { convertDirectusLinkToHref } from '@/src/components/common/Link'
import { DirectusContext } from '@/src/contexts/DirectusContext'
import { CTAButtonProps } from '@/src/components/common/CTAButton/index'
import useTrackingNumber from '@/src/hooks/useTrackingNumber'

export default function CTAButtonClient({
  theme_color,
  chevron,
  behavior,
  link,
  new_window,
  text,
  ...props
}: CTAButtonProps) {
  const directusContext = useContext(DirectusContext)
  const siteSettings = directusContext.SITE_SETTINGS
  const phone_num = siteSettings.phone_number
  if (!phone_num) {
    throw new Error('Phone number is not set in Site Settings')
  }

  const trackingNumber = useTrackingNumber(phone_num)

  let target: HTMLAttributeAnchorTarget | undefined
  let display = text
  let href

  switch (behavior) {
    case 'onboarding':
      href = '#cta-onboarding-form'
      break

    case 'portal_login':
      href = process.env.NEXT_PUBLIC_PORTAL_LOGIN_URL ?? '#'
      break

    case 'phone_number':
      display =
        typeof display === 'string' && display.match(/[\d\s]+/)
          ? trackingNumber
          : display || trackingNumber
      href = `tel:${trackingNumber.replace(/[^\d]/g, '')}`
      break

    default:
      target = new_window ? '_blank' : '_self'
      href = link ? (convertDirectusLinkToHref(link) ?? '#') : '#'
      break
  }
  if (props.href) href = props.href
  if (props.target) target = props.target

  return (
    <a
      {...props}
      href={href}
      target={target}
      onClick={e => {
        if (props.onClick) {
          props.onClick(e)
        }
        switch (behavior) {
          case 'onboarding':
            e.preventDefault()
            window.dispatchEvent(new CustomEvent('onboarding:show'))
        }
        return
      }}
      className={classNames(
        styles.container,
        theme_color == 'inverse' ? styles.inverse : '',
        props.className,
      )}>
      {display}
      {chevron && <SVGChevron fill={'currentColor'} direction={'right'} />}
    </a>
  )
}
